// Lightweight module-level pub/sub bus for the global "Saved" indicator.
// The React Query MutationCache (Task #2874) runs outside React, so it needs a
// plain way to fire into React state. This mirrors the listener pattern used by
// `use-toast.ts`: a Set of listener functions, a subscribe helper that returns
// an unsubscribe cleanup, and a publish helper invoked on every successful
// mutation.

type SavedListener = () => void;

const listeners = new Set<SavedListener>();

export function onSaved(fn: SavedListener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function notifySaved(): void {
  listeners.forEach((fn) => {
    fn();
  });
}
